import React from 'react';
import Cancelicon from '../../svgs/Cancelicon';
import ModalWrapComp from '../ModalWrapComp';
import Styles from './SideDrawer.module.scss';

interface ISideDrawer{
  children:any;
  onClose:()=>void;
  title:string;
  subtitle:string;
  optionalHeader?:any;
}
const SideDrawer = ({
  children, onClose, title, subtitle, optionalHeader,
}:ISideDrawer) => (
  <div className={Styles.wrapper}>
    <ModalWrapComp closeModal={onClose} paddingLeft="0px" paddingRight="0px" justifyContent="flex-end" alignItems="flex-start" contentInModalClass={Styles.wrapper__modalContainer}>
      <div className={Styles.wrapper__title}>{title}</div>
      <div className={Styles.wrapper__subtitle}>{subtitle}</div>
      {
        optionalHeader && <div className={Styles.wrapper__optionalHeader}>{optionalHeader}</div>
      }

      <div className={Styles.wrapper__container}>
        <div className={Styles.wrapper__cancel} onClick={onClose}><Cancelicon color="black" width="8px" height="8px" /></div>
        {children}
      </div>
    </ModalWrapComp>
  </div>
);

export default SideDrawer;
